import { Component, OnInit, ViewChild } from '@angular/core';
import { User } from '../../models/user-model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { UserMasterService } from '../../services/user-master-service';
import { UtilityService } from 'src/app/modules/accounts-module/accounts/services/utility-service';
import { UserCreatePayload } from '../../models/user-create-model';
import { ConfigMasterService } from '../../services/config-master-service'; 
import { NgForm } from '@angular/forms';
import { Role } from '../../models/user-role-model';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { UserUpdatePayload } from '../../models/user-update-model';

@Component({
  selector: 'app-user-master',
  templateUrl: './user-master.component.html',
  styleUrls: ['./user-master.component.css']
})
export class UserMasterComponent implements OnInit {

  hidePassword = true;  

  roles: Role[] = [];

  public l_formDataUser: UserCreatePayload = new UserCreatePayload();
  public isEditMode: boolean = false;
  private editUserId!: number;
  private l_clientId!: number;
  public l_UserRole: string = '';

  constructor(
    private l_UserService: UserMasterService,
    private l_ConfigMasterService: ConfigMasterService,
    private l_UtilityService: UtilityService,
    private router: Router,
    private location: Location
  ) {}

 ngOnInit(): void {
  const data = JSON.parse(sessionStorage.getItem('client_master'));
  this.l_UserRole = sessionStorage.getItem('role');
  this.l_clientId = data.clientId;

  this.lFN_LoadRoles();

  const state = this.location.getState() as any;

  if (state && state.mode === 'edit' && state.data?.userId) {
    this.isEditMode = true;
    this.lFN_GetUserById(state.data.userId);
  } else {
    this.isEditMode = false;

    this.l_formDataUser = new UserCreatePayload();
    this.l_formDataUser.isActive = 'YES';
    this.l_formDataUser.roleId.roleId = 0;
    this.l_formDataUser.deptId.deptId = 1;
    this.l_formDataUser.loginId = '';
    this.l_formDataUser.password = '';
  }
}

lFN_GetUserById(userId: number): void {
  this.l_UtilityService.lFN_ShowLoader();

  this.l_UserService.lFN_GetUserById(userId).subscribe({
    next: (res) => {
      const response = typeof res.body === 'string'
        ? JSON.parse(res.body)
        : res.body;

      if (response?.data) {
        this.lFN_BindUserResponse(response.data);
      }
    },
    error: () => {
      this.l_UtilityService.lFN_ErrorToaster(
        'Failed to load user details',
        'Error'
      );
    },
    complete: () => {
      this.l_UtilityService.lFN_HideLoader();
    }
  });
}

lFN_BindUserResponse(data: any): void {
  this.editUserId = data.userId; 

  this.l_formDataUser.fullName = data.fullName ?? '';
  this.l_formDataUser.loginId = data.loginId ?? '';
  this.l_formDataUser.emailId = data.emailId ?? '';
  this.l_formDataUser.phoneNo = data.phoneNo
    ? String(data.phoneNo)
    : null;

  this.l_formDataUser.isActive = data.isActive ?? 'YES';

  // password disabled in edit
  this.l_formDataUser.password = '';

  this.l_formDataUser.roleId = {
    roleId: data?.role?.roleId ?? 0
  };

  this.l_formDataUser.deptId = {
    deptId: data?.department?.deptId ?? 1
  };
}

private buildUpdatePayload(): UserUpdatePayload {
  return {
    userId: this.editUserId,
    clientId: this.l_clientId,
    fullName: this.l_formDataUser.fullName,
    loginId: this.l_formDataUser.loginId,
    emailId: this.l_formDataUser.emailId,
    phoneNo: this.l_formDataUser.phoneNo
      ? Number(this.l_formDataUser.phoneNo)
      : null, 
    isActive: this.l_formDataUser.isActive,
    roleId: {
      roleId: this.l_formDataUser.roleId.roleId
    },
    deptId: {
      deptId: this.l_formDataUser.deptId.deptId
    }
  };
}



populateUserData(user: UserCreatePayload) {
  this.l_formDataUser = {
    ...user,
    roleId: { roleId: user.roleId?.roleId || 0 }, // map role object
    deptId: { deptId: user.deptId?.deptId || 1 }, // map dept object
  };
}

lFN_LoadRoles(): void {
  this.l_ConfigMasterService.lFN_GetUserRoles().subscribe({
    next: (res) => {
      this.roles = res.data;
    },
    error: () => {
      this.l_UtilityService.lFN_ErrorToaster(
        'Failed to load roles',
        'Error'
      );
    }
  });
}

lFN_ResetForm(form?: NgForm): void {
  if (form) {
    form.resetForm({ isActive: 'YES' });
  }

  this.l_formDataUser = new UserCreatePayload();
  this.l_formDataUser.isActive = 'YES';
  this.l_formDataUser.roleId.roleId = 0;
  this.l_formDataUser.deptId.deptId = 1;

  this.editUserId = 0; // ✅ IMPORTANT
  this.isEditMode = false;
}



lFN_SubmitUser(form: NgForm): void {
  if (form.invalid || this.l_formDataUser.roleId.roleId === 0) {
    this.l_UtilityService.lFN_WarningToaster(
      'Please fill all required fields.',
      'Validation Error'
    );
    return;
  }
  
  const selectedRole = this.roles.find(r => r.roleId === this.l_formDataUser.roleId.roleId);
  if (selectedRole?.roleName === 'SUPER_ADMIN' && this.l_UserRole !== 'SUPER_ADMIN') {
    this.l_UtilityService.lFN_WarningToaster(
      this.isEditMode ? 'Only superadmins can update a user to superadmin role.' : 'Only superadmins can create a superadmin user.',
      'Permission Denied'
    );
    return;
  }

  this.l_UtilityService.lFN_ShowLoader();

  if (this.isEditMode) {
    this.updateUser(form);
  } else {
    this.createUser(form);
  }
}


private createUser(form: NgForm): void {
  const payload: UserCreatePayload = { ...this.l_formDataUser };
  payload.clientId = this.l_clientId;
  
   if (this.l_UserRole != 'SUPER_ADMIN' && this.l_UserRole != 'ADMIN') {
      this.l_UtilityService.lFN_WarningToaster(
        'Only superadmins and admins can create the user.',
        'Permission Denied'
      );
      return;
    }


  this.l_UserService.lFN_SaveUser(payload).subscribe({
    next: (res: any) => {
      this.l_UtilityService.lFN_SuccessToaster(
        'User created successfully',
        'Success'
      );

      this.lFN_ResetForm(form);

      this.l_UtilityService.lFN_Navigate('userlist', 'userlist');
    },
    error: (err) => {
      console.error(err);
      this.l_UtilityService.lFN_ErrorToaster(
        'Failed to create user',
        'Error'
      );
      this.l_UtilityService.lFN_HideLoader();
    },
    complete: () => {
      this.l_UtilityService.lFN_HideLoader();
    }
  });
}

private updateUser(form: NgForm): void {
  const payload = this.buildUpdatePayload();

  this.l_UserService.lFN_UpdateUser(payload).subscribe({
    next: (res: any) => {
      this.l_UtilityService.lFN_SuccessToaster(
        'User updated successfully',
        'Success'
      );

      this.lFN_ResetForm(form);

      this.l_UtilityService.lFN_Navigate('userlist', 'userlist');
    },
    error: (err) => {
      console.error(err);
      this.l_UtilityService.lFN_ErrorToaster(
        'Failed to update user',
        'Error'
      );
      this.l_UtilityService.lFN_HideLoader();
    },
    complete: () => {
      this.l_UtilityService.lFN_HideLoader();
    }
  });
}

 

}
